import {
    ASSESSMENT_QUESTIONS,
    EVAL_ASSESSMENT,
    JOB_DETAILS,
    SCREEN_DETAILS,
} from "./constants/default"
import { AssessmentQuestions } from "./utils/assessment-types"
import createStore from "./utils/create-store"
import { ScreenDetails } from "./utils/screen-details-types"
import { JobDetails } from "./utils/types"
import { enableMapSet } from "immer"
import { EvalAssessment } from "./utils/eval-assessment-types"

interface IAssessmentStore {
    popupStacks: Array<string>
    currentStep: number
    assesmentQuestions: AssessmentQuestions
    jobDetails: JobDetails
    answeredQuestions: Set<object>
    evalAssessment: EvalAssessment
    openExitFlow: boolean
    openSuccessFlow: boolean
    screenDetails: ScreenDetails
    setOpenExitFlow: (value: boolean) => void
    setOpenSuccessFlow: (value: boolean) => void
    setAnsweredQuestions: (
        questionId: number,
        questionType: string,
        answerId?: string[]
    ) => void
    updateCurrentStep: () => void
    onSkipStep: () => void
    setJobDetails: (data: JobDetails) => void
    setAssessmentQuestions: (data: AssessmentQuestions) => void
    setAssessmentTest: () => void
    setScreenDetails: (data: ScreenDetails) => void
    setEvalAssessment: (data: EvalAssessment) => void
    addToPopupStack: (popupId: string) => void
    removeLastPopup: () => void
}

enableMapSet()

export const useAssessmentStore = createStore<IAssessmentStore>((set) => {
    return {
        popupStacks: [],
        // add default values
        currentStep: 0,
        assesmentQuestions: {
            ...ASSESSMENT_QUESTIONS,
        } as unknown as AssessmentQuestions,
        jobDetails: { ...JOB_DETAILS } as unknown as JobDetails,
        answeredQuestions: new Set(),
        evalAssessment: { ...EVAL_ASSESSMENT } as unknown as EvalAssessment,
        openExitFlow: false as boolean,
        // rename variable
        openSuccessFlow: false as boolean,
        screenDetails: { ...SCREEN_DETAILS } as unknown as ScreenDetails,
        setOpenExitFlow: (value: boolean) => {
            set((state) => {
                state.openExitFlow = value
            })
        },
        setOpenSuccessFlow: (value: boolean) => {
            set((state) => {
                state.openSuccessFlow = value
            })
        },
        setAnsweredQuestions: (
            questionId: number,
            questionType: string,
            answerId?: string[]
        ) => {
            const answers = {
                question_id: `${questionId}`,
                question_type: questionType,
                ...(answerId && answerId?.length > 0 && { answer_id: answerId }),
            }
            set((state) => {
                // keeping account of question answered
                state.answeredQuestions.add(answers)
            })
        },
        updateCurrentStep: () => {
            set((state) => {
                // number of question
                state.currentStep = state.currentStep + 1
            })
        },
        onSkipStep: () => {
            set((state) => {
                state.currentStep = state.currentStep + 1
            })
        },
        setJobDetails: (data: JobDetails) => {
            set((state) => {
                state.jobDetails = data
            })
        },
        setAssessmentQuestions: (data: AssessmentQuestions) => {
            set((state) => {
                state.assesmentQuestions = data
            })
        },
        setAssessmentTest: () => {
            set((state) => {
                state.assesmentQuestions.mandatory = false
            })
        },
        setScreenDetails: (data: ScreenDetails) => {
            set((state) => {
                state.screenDetails = data
            })
        },
        setEvalAssessment: (data: EvalAssessment) => {
            set((state) => {
                state.evalAssessment = data
            })
        },
        addToPopupStack: (popupId: string) => {
            set((state) => {
                state.popupStacks.push(popupId)
            })
        },
        removeLastPopup: () => {
            set((state) => {
                state.popupStacks.pop()
            })
        },
    }
})
